import React, { useState } from "react";

function PrivacySection() {
  const [showPrivacyManagement, setShowPrivacyManagement] = useState(false);

  function handleManageClick() {
    setShowPrivacyManagement(true);
  }

  function handleClosePrivacyManagement() {
    setShowPrivacyManagement(false);
  }

  return (
    <>
      <h2 className="text-xl font-semibold mb-4">Privacy</h2>
      <div className="flex justify-between items-center border-b pb-4">
        <p className="text-gray-500">rishabhsagarajmer@gmail.com</p>
        <button
          className="text-blue-500 font-medium"
          onClick={handleManageClick}
        >
          Manage
        </button>
      </div>
      {showPrivacyManagement && (
       <div className="absolute top-0 left-0 w-screen h-screen bg-white z-10">
       <div className="bg-white max-w-xl mx-auto py-6 px-8 rounded-md shadow">
         <button
           className="absolute top-2 right-2 text-gray-400"
           onClick={handleClosePrivacyManagement}
         >
           <svg
             xmlns="http://www.w3.org/2000/svg"
             className="h-6 w-6"
             fill="none"
             viewBox="0 0 24 24"
             stroke="currentColor"
           >
             <path
               strokeLinecap="round"
               strokeLinejoin="round"
               strokeWidth={2}
               d="M6 18L18 6M6 6l12 12"
             />
           </svg>
         </button>
         <h3 className="text-xl font-semibold mb-4">
           Privacy management center
         </h3>
         <p className="text-gray-500 mb-4">
           Exercise your privacy rights under local law. To make a request to
           our Data Protection Office, use the ‘Data subject request form’
           tab. To opt out of specific data processing activities, please go
           to ‘Preferences’.
         </p>
         <p className="text-gray-500 mb-4">
           If your request relates to a rental car or taxi reservation, you
           may also receive a response from Booking.com Transport Limited.
           This is because these services are provided in cooperation with
           Booking.com Transport Limited.
         </p>
         <p className="text-gray-500 mb-4">
           For more information, or to exercise other rights, please take a
           look at our Booking.com Privacy Statement, the Booking.com
           Transport Limited Privacy Statement for Cars and the Booking.com
           Transport Limited Privacy Statement for Taxis.
         </p>
         
         <form>
           <div className="grid grid-cols-2 gap-4 mb-4">
             <div>
               <label
                 htmlFor="privacy-first-name"
                 className="block text-gray-500 font-medium mb-2"
               >
                 First name(s)*
               </label>
               <input
                 type="text"
                 id="privacy-first-name"
                 name="privacy-first-name"
                 required
                 className="border border-gray-300 px-2 py-1 w-full"
               />
             </div>
             <div>
               <label
                 htmlFor="privacy-last-name"
                 className="block text-gray-500 font-medium mb-2"
               >
                 Last name(s)*
               </label>
               <input
                 type="text"
                 id="privacy-last-name"
                 name="privacy-last-name"
                 required
                 className="border border-gray-300 px-2 py-1 w-full"
               />
            
            </div>
         <div className="flex flex-col mb-4">
           <label
             htmlFor="privacy-email"
             className="text-gray-600 font-medium mb-2"
           >
             Email address*
           </label>
           <input
             type="email"
             id="privacy-email"
             name="privacy-email"
             required
             className="border border-gray-300 px-2 py-1 w-full"
           />
         </div>
         <p className="text-gray-600 mb-4">
           Which of the following rights would you like to exercise?
         </p>
         <div className="flex flex-col mb-4">
           <label className="text-gray-600 font-medium mb-2">
             Right of access to personal data
             <input type="radio" name="privacy-right" value="access" />
           </label>
           <p className="text-gray-500 text-sm mb-4">
             Get a copy of your personal data.
           </p>
           <label className="text-gray-600 font-medium mb-2">
             Right to be forgotten
             <input type="radio" name="privacy-right" value="forgotten" />
           </label>
           <p className="text-gray-500 text-sm mb-4">
             Erase your personal data from our system.
           </p>
           <label className="text-gray-600 font-medium mb-2">
             Unsubscribe from email marketing
             <input type="radio" name="privacy-right" value="unsubscribe" />
           </label>
           <p className="text-gray-500 text-sm mb-4">
             Manage your subscription to our mailing lists.
           </p>
           <label className="text-gray-600 font-medium mb-2">
             Right to object to data sharing with other companies in the
             Booking Holdings Inc. corporate group
             <input type="radio" name="privacy-right" value="object" />
           </label>
           <p className="text-gray-500 text-sm mb-4">
             Right to object to data sharing with other companies in the
             Booking Holdings Inc. corporate group
           </p>
         </div>
         <p className="text-gray-600 mb-4">
           Please provide us one of the following references to verify your
           request
         </p>
         <div className="flex flex-col mb-4">
           <label
             htmlFor="privacy-booking-number"
             className="text-gray-600 font-medium mb-2"
           >
             Booking.com accommodation confirmation number
           </label>
           <input
             type="text"
             id="privacy-booking-number"
             name="privacy-booking-number"
             className="border border-gray-300 px-2 py-1 w-full"
           />
           <label
             htmlFor="privacy-car-number"
             className="text-gray-600 font-medium mb-2 mt-4"
           >
             Booking.com car reservation number
           </label>
           <input
             type="text"
             id="privacy-car-number"
             name="privacy-car-number"
             className="border border-gray-300 px-2 py-1 w-full"
           />
           <label
             htmlFor="privacy-taxi-number"
             className="text-gray-600 font-medium mb-2 mt-4"
           >
             Booking.com taxi reference number
           </label>
           <input
             type="text"
             id="privacy-taxi-number"
             name="privacy-taxi-number"
             className="border border-gray-300 px-2 py-1 w-full"
           />
           <label
             htmlFor="privacy-previous-confirmation"
             className="text-gray-600 font-semibold mb-1 block"
             >
             Confirmation number from a previous booking:
             </label>
             <input
                          type="text"
                          id="privacy-previous-confirmation"
                          name="privacy-previous-confirmation"
                          className="border border-gray-300 px-2 py-1 w-full"
                        />
             <label
                          htmlFor="privacy-pin-code"
                          className="text-gray-600 font-semibold mb-1 block"
                        >
             PIN code from that same booking:
             </label>
             <input
                          type="text"
                          id="privacy-pin-code"
                          name="privacy-pin-code"
                          className="border border-gray-300 px-2 py-1 w-full"
                        />
             <button
                          className="bg-green-500 text-white px-4 py-2 rounded mt-4 hover:bg-green-600"
                          onClick={handleManageClick}
                        >
             Submit request
             </button>
             </div>
             </div>
             </form>
             </div>
             </div>
                
                )
                }
                </>)}
    export default PrivacySection;